import { useEffect, useRef } from "react";
import { subscribeToIncidents } from "@/services/incidentService";

export function useIncidentSocket(callback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    const unsubscribe = subscribeToIncidents((incidentData) => {
      if (typeof callbackRef.current === "function") {
        callbackRef.current(incidentData);
      }
    });

    return () => {
      unsubscribe?.();
    };
  }, []);
}
